import { Button } from '@mui/material';

import { Modal, Typography } from '@mui/material';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../../store/store';
import { IUser } from '../../../../shared/interfaces/user/IUser';
import { darkPalette } from '../../../../shared/mui/palettes';
import { ETheme } from '../../../../shared/enums/user/ETheme';
import { lightPalette } from '../../../../shared/mui/palettes';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';

interface IProps {
  open: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  children: JSX.Element;
  isUpdate?: boolean;
  isLoading?: boolean;
}
const LeaveDayFormModal = ({
  open,
  handleClose,
  isUpdate = false,
  isLoading = false,
  handleSubmit,
  children,
}: IProps) => {
  const { t } = useTranslation();
  const { theme } = useSelector(
    (state: RootState) => state?.auth?.userData,
  ) as IUser;
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className={'MuiModalBody'}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: { xs: '80%', lg: '30%' },
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%',
            paddingBottom: '10px',
            borderBottom: `1px solid ${theme === ETheme.LIGHT ? lightPalette.primary.light : darkPalette.background.light}`,
          }}
        >
          <Typography id="modal-modal-title" variant="h6">
            {t(isUpdate ? 'leaveDays.updateLeave' : 'leaveDays.createLeave')}
          </Typography>
        </Box>
        {children}
        <div>
          <Button
            variant={'contained'}
            color={'secondary'}
            size={'small'}
            onClick={handleClose}
            sx={{ marginRight: '10px' }}
          >
            {t('button.cancel')}
          </Button>

          <LoadingButton
            loading={isLoading}
            variant="contained"
            type={'button'}
            onClick={handleSubmit}
          >
            {t(isUpdate ? 'button.update' : 'button.create')}
          </LoadingButton>
        </div>
      </Box>
    </Modal>
  );
};

export default LeaveDayFormModal;
